import React, { useMemo } from 'react'
import { Button, Form, Select, TreeSelect, Image } from 'antd'
import { YhForm } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhForm } from '@/components/YhFormBox/Types'
import { useThreeTestItemModel } from '../threeTestItemModel'
import { vehicleTypeList } from '@/types/AppEnums'

export const FormBox = () => {
    const { setSelectedNodes, onSubmit, formVal, onChangeFormVal, selectedNodes, treeSource } = useThreeTestItemModel()

    // 递归过滤掉自己和自己的子项
    const filterTreeData = useMemo(() => {
        const filterNodes = (nodes: any, excludeKey: any) => {
            return nodes
                .filter((node: any) => node.key !== excludeKey)
                .map((node: any) => {
                    const newNode = { ...node }
                    if (newNode.children && newNode.children.length > 0) {
                        newNode.children = filterNodes(newNode.children, excludeKey)
                    }
                    return newNode
                })
        }
        return filterNodes(treeSource, formVal?.key)
    }, [treeSource, formVal])

    // 转换树数据为TreeSelect格式
    const convertTreeData = (data: any) => {
        return data.map((item: any) => ({
            title: item.name,
            value: item.code,
            children: item.children ? convertTreeData(item.children) : [],
        }))
    }

    const treeSelectData = useMemo(() => {
        return convertTreeData(filterTreeData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterTreeData])

    // 构建基础表单配置
    const baseFormItems = [
        {
            type: FormItemTypeEnum.Input,
            fieldLabel: '父级编码',
            fieldName: 'pcode',
            span: 13,
            disable: true,
        },
        {
            type: FormItemTypeEnum.Other,
            fieldLabel: '修改父级',
            fieldName: 'pcode',
            span: 13,
            formItem: (
                <Form.Item name="pcode" label="修改父级">
                    <TreeSelect
                        style={{ width: '100%' }}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        treeData={treeSelectData}
                        placeholder="请选择父级"
                        treeDefaultExpandAll
                        disabled={true}
                    />
                </Form.Item>
            ),
        },
        {
            type: FormItemTypeEnum.Input,
            fieldLabel: '三检项目编码',
            fieldName: 'code',
            span: 13,
            disable: true,
        },
        {
            type: FormItemTypeEnum.Input,
            fieldLabel: '三检项目名称',
            fieldName: 'name',
            span: 13,
            disable: true,
        },
        {
            type: FormItemTypeEnum.Other,
            fieldLabel: '车辆类型',
            fieldName: 'vehicleType',
            span: 13,
            formItem: (
                <Form.Item name="vehicleType" label="车辆类型">
                    <Select mode="multiple" showSearch options={vehicleTypeList} placeholder="车辆类型" disabled={true} />
                </Form.Item>
            ),
        },
        {
            type: FormItemTypeEnum.Switch,
            fieldLabel: '强制上传照片',
            fieldName: 'enableStatus',
            span: 13,
            hidden: formVal.children?.length > 1,
        },
    ]

    // 只有当是第一级节点时才添加车型图样字段（第一级节点的pcode为空或null）
    const formItems = formVal?.pcode
        ? baseFormItems
        : [
              ...baseFormItems,
              {
                  type: FormItemTypeEnum.Other,
                  fieldLabel: '车型图样',
                  fieldName: 'vehicleImage',
                  span: 13,
                  formItem: (
                      <Form.Item label="车型图样" name="vehicleImage">
                          <Image width={200} src={formVal?.vehicleImage} />
                      </Form.Item>
                  ),
              },
          ]

    const formConfig: IYhForm = {
        labelCol: { span: 8 },
        formValues: formVal,
        onChange: onChangeFormVal,
        items: formItems,
    }

    return (
        <>
            <div className="dict-list-header" style={{ paddingBottom: '20px' }}>
                <span className="dict-from-title">{selectedNodes[0].name === '' ? '一级三检项目' : selectedNodes[0].name} </span>
            </div>
            <div>
                <YhForm {...formConfig} />
            </div>
            <div
                style={{
                    float: 'right',
                    marginTop: '25px',
                    width: '55%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                }}
            >
                <Button type="link" shape="round" onClick={() => onSubmit(formVal)}>
                    保存
                </Button>
                <Button type="link" shape="round" onClick={() => setSelectedNodes([])}>
                    取消
                </Button>
            </div>
        </>
    )
}
